import React, { useState } from "react";

import { Box, Typography, Chip } from "@mui/material";

import { faGooglePlay, faApple } from "@fortawesome/free-brands-svg-icons";

import IconLink from "./IconLink";
import Style from "../BaseLayout.module.scss";

function PortfolioBlock(props) {
  const {
    image,
    icon,
    title,
    description,
    tech,
    features,
    googlePlay,
    appStore,
  } = props;

  const FEATURES_LIMIT = 10;
  const [expanded, setExpanded] = useState(false);

  const hasMore = features?.length > FEATURES_LIMIT;
  const visibleFeatures = expanded
    ? features
    : features?.slice(0, FEATURES_LIMIT);

  return (
    <Box
      className={Style.card}
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      {/* HEADER */}

      <Box
        sx={{
          p: 2.5,
          pb: 2,
        }}
      >
        <Box display="flex" alignItems="flex-start" gap={2}>
          <Box
            component="img"
            src={icon}
            alt={title}
            sx={{
              width: "58px",
              height: "58px",

              borderRadius: "16px",

              objectFit: "cover",

              flexShrink: 0,
            }}
          />

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: "1.3rem",
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                opacity: 0.7,
                mt: 0.5,
                fontSize: "0.9rem",
                lineHeight: 1.5,
              }}
            >
              {description}
            </Typography>
          </Box>
        </Box>

        {/* TECH STACK */}

        <Box display="flex" flexWrap="wrap" gap={1} mt={2.5}>
          {tech?.map((item, index) => (
            <Chip key={index} label={item} size="small" className={Style.chip} />
          ))}
        </Box>
      </Box>

      {/* PHONE MOCKUP */}

      <Box
        sx={{
          height: {
            xs: "320px",
            md: "350px",
          },

          display: "flex",

          justifyContent: "center",

          alignItems: "center",

          overflow: "hidden",

          px: 2,

          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: {
              xs: "900px",
              md: "1000px",
            },

            transition: "0.5s ease",

            "&:hover": {
              transform: "scale(1.03)",
            },
          }}
        >
          <Box
            component="img"
            src={image}
            alt={title}
            sx={{
              width: "100%",

              display: "block",

              borderRadius: "35px",
            }}
          />
        </Box>
      </Box>

      {/* FEATURES */}

      <Box
        sx={{
          px: 2.5,

          pt: 2,

          flex: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,

            mb: 1,

            fontSize: "0.95rem",
          }}
        >
          Features
        </Typography>

        <Box display="flex" flexDirection="column" gap={0.6}>
          {visibleFeatures?.map((feature, index) => (
            <Typography
              key={index}
              sx={{
                opacity: 0.75,

                fontSize: "0.85rem",

                lineHeight: 1.4,
              }}
            >
              • {feature}
            </Typography>
          ))}
        </Box>

        {hasMore && (
          <Typography
            onClick={() => setExpanded((prev) => !prev)}
            sx={{
              mt: 1,
              fontSize: "0.8rem",
              fontWeight: 600,
              opacity: 0.9,
              cursor: "pointer",
              width: "fit-content",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {expanded ? "See less" : "See more"}
          </Typography>
        )}
      </Box>

      {/* BUTTONS */}

      <Box
        display="flex"
        gap={1.5}
        p={2.5}
        flexWrap="wrap"
        sx={{
          mt: "auto",
        }}
      >
        <Box flex={1} minWidth="140px">
          <IconLink link={googlePlay} title="Google Play" icon={faGooglePlay} />
        </Box>

        <Box flex={1} minWidth="140px">
          <IconLink link={appStore} title="App Store" icon={faApple} />
        </Box>
      </Box>
    </Box>
  );
}

export default PortfolioBlock;